import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';

export function getEditorVersionContent(url: string): Promise<string> {
  return FetchPromise.get(url, null, '');
}

export function useEditorVersionContentQuery(
  { url }: { url: string },
  queryOptions: UseQueryOptions<string, JQuery.jqXHR> = {},
) {
  return useQuery({
    queryKey: ['text-editor-version-content', url],
    queryFn: () => getEditorVersionContent(url),
    ...queryOptions,
  });
}
